// #TODO: TO FETCH ENV NAME FROM ENV VARIABLES
const { hostname } = window.location;
const parts = hostname.split(".");

const BASE_URL_MAPPING = {
  devdb: "https://api.devdb.sagetransparency.org",
  dev2: "https://zia37asmd9.execute-api.us-east-2.amazonaws.com/dev2",
  dev2db: "https://zia37asmd9.execute-api.us-east-2.amazonaws.com/dev2",
  uatdb: "https://api.uatdb.sagetransparency.org",
  dashboard: "https://api.sagetransparency.org",
};

// const BASE_API_URL = BASE_URL_MAPPING.dev2;
let BASE_URL = BASE_URL_MAPPING.devdb;
if (parts.length > 2 && BASE_URL_MAPPING[parts[0]]) {
  BASE_URL = BASE_URL_MAPPING[parts[0]];
}

const endpoints = {
  login: {
    resource: "api/v1/auth/login",
  },
  quicksight: {
    resource: `${BASE_URL}/dashboard`,
  },
  efiHome: {
    resource: "https://employerptp.org/",
  },
  feedback: {
    resource: "https://www.surveymonkey.com/r/sagetransparencyfeedback2",
  },
  getUsers: {
    resource: `${BASE_URL}/users`,
  },
  deleteUser: {
    resource: `${BASE_URL}/user`,
  },
  createNewUser: {
    resource: `${BASE_URL}/user`,
  },
  updateUser: {
    resource: `${BASE_URL}/user`,
  },
  getUserAuditLogs: {
    resource: `${BASE_URL}/activity-logs`,
  },
  // BELOW APIS ARE NOT GETTING CALLED
  getGuestUserSessions: {
    resource: "https://30m53kp6a8.execute-api.us-east-2.amazonaws.com/dev/monthly-count-data",
  },
  getSubscribedUserSessions: {
    resource: "https://30m53kp6a8.execute-api.us-east-2.amazonaws.com/dev/monthly-count-data",
  },
  getGuestUserPaidReports: {
    resource: "https://30m53kp6a8.execute-api.us-east-2.amazonaws.com/dev/monthly-count-data",
  },
  getSubscribedUserReports: {
    resource: "https://30m53kp6a8.execute-api.us-east-2.amazonaws.com/dev/monthly-count-data",
  },
  getMonthlyCount: {
    resource: `${BASE_URL}/monthly-count-data`,
  },
  getPurchasesData: {
    resource: `${BASE_URL}/get-purchases-data`,
  },
  getTransactionsData: {
    resource: `${BASE_URL}/get-transactions-data`,
  },
  getSubscribedUsers: {
    resource: "https://30m53kp6a8.execute-api.us-east-2.amazonaws.com/dev/subscribed-user-sessions",
  },

  // NEW APIs
  getRevenueData: {
    resource: `${BASE_URL}/revenue-count`,
  },
  getDashboardData: {
    resource: `${BASE_URL}/user-session-dashboard-count`,
  },
  getSessionCount: {
    resource: `${BASE_URL}/user-session-count`,
  },

  getPricingDetails: {
    resource: "",
  },
  getStates: {
    resource: `${BASE_URL}/mv-hospital-states`,
  },
  getPlans: {
    resource: `${BASE_URL}/purchase-plan`,
  },
  getPurchaseMappingns: {
    resource: `${BASE_URL}/get-purchase-ds-mapping`,
  },
  getRegionsAndHospitals: {
    resource: `${BASE_URL}/mv-hospital-user-selection`,
    // resource: "https://xq2lzk2jp4.execute-api.us-east-2.amazonaws.com/dev/mv-hospital-user-selection",
  },
  getStripePublishKey: {
    resource: `${BASE_URL}/payment-config`,
  },
  getStripeClientSecret: {
    resource: `${BASE_URL}/create-payment-intent`,
  },
  postTransactionDetails: {
    resource: `${BASE_URL}/save-transaction-details`,
  },
  deleteStripePaymentIntent: {
    resource: `${BASE_URL}/payment-delete`,
  },
  getGeneratedDatasetURL: {
    resource: `${BASE_URL}/get-purchase-url`,
  },
  generateDataset: {
    resource: `${BASE_URL}/generate-purchase-dataset`,
  },
  transactionLogs: {
    resource: `${BASE_URL}/get-transactions-logs`,
  },
  createUserSessions: {
    resource: `${BASE_URL}/user-session`,
  },
  resendDataset: {
    resource: `${BASE_URL}/resend-purchase-dataset`,
  },
  userSession: {
    resource: `${BASE_URL}/user-session`,
  },
  masterDataset: {
    resourvce: `${BASE_URL}/get-master-dataset-link`,
  },
};

export default endpoints;
